export const V1_RECEIVE_NOTIFICATIONS = 'V1_RECEIVE_NOTIFICATIONS'

export default notifications => ({
  type: V1_RECEIVE_NOTIFICATIONS,
  notifications,
})
